import { Theme } from '@emotion/react';
import { Components, TextFieldProps } from '@mui/material';
import { muiTextFieldPropsOverride } from './TextField';
import type { PickersTextFieldProps } from '@mui/x-date-pickers';

//They are slightly different now, but are still very similar for what we change.
//In case of type errors here - test both TextField and DatePickers UI
type Common = Partial<PickersTextFieldProps> & Partial<TextFieldProps>;

function DatePickers(): Partial<Components<Theme>> {
  return {
    MuiPickersTextField: {
      defaultProps: muiTextFieldPropsOverride as Common,
    },
  };
}

export default DatePickers;
